import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import AdminDashboardReadSchemaRequest from '@careerstart/wae-common/schema/agency/dashboard/admin.agency.dashboard.read.req.json';

import { validateSchema } from '../../../../components/Form/validations';
import {
  selectIsWidgetDataLoading,
  selectWidgetData,
  selectWidgetError,
} from '../../../../store/selectors/dashboardSelector';
import { getWidgetData } from '../../dashboardReducer';

/**
 * Custom hook for fetching admin global dashboard data
 * Only fetches sitewide admin data, not agency-specific data
 */
const useAdminGlobalDashboardDataFetching = () => {
  const dispatch = useDispatch();
  const isWidgetDataLoading = useSelector(selectIsWidgetDataLoading);
  const widgetData = useSelector(selectWidgetData);
  const widgetError = useSelector(selectWidgetError);

  useEffect(() => {
    if (!isWidgetDataLoading && widgetData === undefined && !widgetError) {
      const payload = {};
      const schemaErrors = validateSchema(payload, AdminDashboardReadSchemaRequest);

      // FIXME: We do not want to do runtime checks for API validation. This will break the app.
      // Instead, we need to write automated tests that gaurantee our code matches API schemas.
      if (Object.keys(schemaErrors).length === 0) {
        dispatch(getWidgetData(payload));
      }
    }
  }, [dispatch, isWidgetDataLoading, widgetData, widgetError]);

  return {
    isWidgetDataLoading,
    widgetData,
    widgetError,
  };
};

export default useAdminGlobalDashboardDataFetching;
